// import moment from 'moment';

const moment = require("moment");

module.exports = {


    methods: {
        /**
         * Builds the information that the front end requires for each basket item
         * @type {object} product
         * @type {object} basket config
         * @return object
         */
        buildBasketItem(product, config, basket_index){

            if (!config.custom_price_modifier_value) {
              var price_modifier = product.PriceModifiers.find(product_modifier => product_modifier.id == config.price_modifier);
            }

            return {

                index         :basket_index,
                title         :product.name,
                type          :product.ProductType.id,
                image         :product.image,
                price_modifier: price_modifier ? price_modifier : null,
                custom_price_modifier_value: config.custom_price_modifier_value ? config.custom_price_modifier_value : null,
                quantity      :config.quantity,
                message       :config.message,
                delivery_type :config.delivery_type,
                total_display :config.custom_price_modifier_value && !price_modifier ? this.getPriceDisplayValue(config.custom_price_modifier_value, config.quantity) : this.getPriceModifierDisplayValue(price_modifier, config.quantity),
                product       :product,
                quantity_configs: config.quantity_config,
                event_slot_id:    config.event_slot_id ? config.event_slot_id : null,
                unit_id:      config.event_location ? config.event_location : null,
                age_restricted: product.age_restricted
            };


        },


        /**
         * Removes a product from the basket
         * @type {object} product
         * @type {object} basket config
         * @return object
         */
        removeProduct(item)
        {
            this.$store.commit('basket/REMOVE_FROM_BASKET', item.index);
        },


        closeEdit()
        {
            this.edit_product = false;
        },

        getScheduledForDateTime(item_index, quantity_index)
        {
            if(this.basket[item_index].quantity_configs[quantity_index]?.schedule_selected === 'future')
            {
                const date = this.basket[item_index].quantity_configs[quantity_index].scheduled_date;
                const time = this.basket[item_index].quantity_configs[quantity_index].scheduled_time;

                if(date && time) {
                    const date_format = this.phpDateFormatToJs(this.accountDateFormat);
                    const local_time = moment(date + ' ' + time, date_format + ' hh:mm');

                    return local_time.utc().format('YYYY-MM-DD HH:mm:ss');
                }
            }
            return null;
        },
        
        getDigitalDeliveryFee: function (payload) {
            let fee = 0
            payload.order_items.forEach((oi) => {
                const digitalDeliveryFee = this.getDigitalDeliveryPrice(oi.fulfilment_method_id)
                fee += digitalDeliveryFee
            })
            return fee
        },

    },

    watch :{

        // if the basket changes, cancel the pending order
        basket:{
            handler: function(){
                if(this.pendingOrder.id){
                  this.$store.dispatch('basket/cancelPendingOrder', this.pendingOrder);
                }
            },
            deep:true
        }
    },

    computed: {


        pendingOrder()
        {
            return this.$store.getters['basket/getPendingOrder'];
        },

        // total value of order
        orderTotal()
        {
            return this.orderApiPayload.total;
        },

        // balance already paid on order
        balancePaid()
        {
            // this was used for gift card payments, which are depreciated
            /*if(this.pendingOrder.id){
              return this.pendingOrder.balance_paid;
            }*/
            return 0;
        },

        // the amount left to pay
        remaining_balance()
        {
          return this.orderTotal;
        },

        // returns unique array of offer display text for all offers in basket
        orderSpecialOffers()
        {
          let specialOffers = [];
          for(var i = 0; i < this.basket.length; i++)
            if(this.basket[i].product.AutomaticPromotions.data.length > 0) // postal fulfilment
              specialOffers.push(this.basket[i].product.AutomaticPromotions.data[0].display_text);
          return [...new Set(specialOffers)];
        },

        /**
         * Gets the current basket with the product information included
         * @return array of products
         */

        basket() {

          if(this.$store === undefined)
            return [];


          //get basket items
          var basket = this.$store.getters['basket/getBasket'];

          var toReturn = [];

          // get product for each basket item
          for(var i = 0; i < basket.length; i++){

              var product = this.getProductByID(basket[i].id);

              // if the product exists push it to the array to return
              if(product){
                  var item = this.buildBasketItem(product, basket[i], i);
                  toReturn.push(item);
              }
          }

          return toReturn;

        },

        /**
         * GBasket is being sent as a group Delivery
         * @return Bool
         */

        groupedDelivery()
        {
            return this.$store.getters['basket/getGroupCardTypes'];
        },


        basketDiscountValue()
        {
            return this.$store.getters['basket/getBasketDiscountValue'];
        },

        // validated promotional code or gift card payment config
        basketPromotionalCode()
        {
          return this.$store.getters['basket/getBasketPromotionalCode'];
        },

        // validating promotional code or gift card payment config
        validatingPromotionalCode()
        {
          return this.$store.getters.getRetrievingBasketPromoCode;
        },

        checkoutPromoCode()
        {
          return this.validatingPromotionalCode.code ? this.validatingPromotionalCode : this.basketPromotionalCode;
        },

        shippingCost() {
          let shipping_cost = {
            price                            : 0,
            denomination                     : 100
          };

          if(this.groupedDelivery){
            // post group fulfilment
            if(this.orderContainsPostFulfilment){
              var group_fulfilment = this.$store.getters['basket/getGroupedFulfilmentConfig'];
              if (group_fulfilment.post_type) {
                shipping_cost.price = group_fulfilment.post_type.price;
                shipping_cost.denomination = group_fulfilment.post_type.Currency.denomination;
              }
            }
          } else {
            for(var i = 0; i < this.basket.length; i++) {
              for(var c = 0; c < this.basket[i].quantity_configs.length; c++) {
                // non group fulfilment options
                if(this.basket[i].delivery_type == 2) { // postal fulfilment
                  var post_type = this.basket[i].quantity_configs[c].post_type;
                  if (post_type) {
                    shipping_cost.price += post_type.price;
                    shipping_cost.denomination = post_type.Currency.denomination;
                  }
                }
              }
            }
          }
          shipping_cost.price += this.getDigitalDeliveryFee(this.orderApiPayload)

          return shipping_cost;
        },

        orderContainsPostFulfilment()
        {
          var containsPost = false;
          for(var i = 0; i < this.basket.length; i++)
                  if(this.basket[i].delivery_type == 2) // postal fulfilment
                      containsPost = true;
          return containsPost;
        },

        orderContainsEmailFulfilment()
        {
          var containsEmail = false;
          for(var i = 0; i < this.basket.length; i++)
                  if(this.basket[i].delivery_type == 1) // email fulfilment
                      containsEmail = true;
          return containsEmail;
        },


        // does the basket contain a postage item?
        basketContainsPostageItem()
        {
            let found = false;
            for(var i = 0; i < this.basket.length; i++){
              for(var c = 0; c < this.basket[i].quantity_configs.length; c++){
                if(this.basket[i].delivery_type == 2)
                  found = true;
              }
            }
            return found;
        },

        orderApiPayloadDiscounts()
        {

        },


        /**
         * Create the payload for the order API
         * @return Bool
         */


        orderApiPayload()
        {

          let account = this.$store.getters["getAccount"];
          const recipient = this.$store.getters['basket/getGroupedFulfilmentConfig'].recipient_type;
          const groupSendingToMyself = recipient === 'Myself';
          
          var payload = {
            total                           : 0,
            currency                        : account.Currency.iso_currency_code,
            order_items                     : [],
            group_fulfilment                : this.groupedDelivery,
            age_verified                    : this.ageVerified,
            group_recipient                 : recipient
          };

          // group fulfilment options
          if(payload.group_fulfilment){

            // post group fulfilment
            if(this.orderContainsPostFulfilment){
              payload.group_fulfilment_address = {
                name                            : this.$store.getters['basket/getGroupedFulfilmentConfig'].name,
                address_line_1                  : this.$store.getters['basket/getGroupedFulfilmentConfig'].address_line_1,
                address_line_2                  : this.$store.getters['basket/getGroupedFulfilmentConfig'].address_line_2,
                town_city                       : this.$store.getters['basket/getGroupedFulfilmentConfig'].town_city,
                postcode                        : this.$store.getters['basket/getGroupedFulfilmentConfig'].postcode,
                country_code                    : this.$store.getters['basket/getGroupedFulfilmentConfig'].country_code,
              };
              if(this.$store.getters['basket/getGroupedFulfilmentConfig'].post_type.id !== false)
                payload.group_fulfilment_postage_category_id = this.$store.getters['basket/getGroupedFulfilmentConfig'].post_type.id;
            }

            // email group fulfilment
              if(this.orderContainsEmailFulfilment){
                  if(!groupSendingToMyself) {
                      // we're not sending all items to myself so we need to send through the group fulfilment config
                      payload.group_fulfilment_contact = {
                          first_name                       : this.$store.getters['basket/getGroupedFulfilmentConfig'].first_name,
                          last_name                        : this.$store.getters['basket/getGroupedFulfilmentConfig'].last_name,
                          email                            : this.$store.getters['basket/getGroupedFulfilmentConfig'].email,
                          phone_number                     : this.$store.getters['basket/getGroupedFulfilmentConfig'].phone_number
                      }
                  }
              }
          }

          payload.discounts = [];



          // create order items
          for(var i = 0; i < this.basket.length; i++){
              for(var c = 0; c < this.basket[i].quantity_configs.length; c++){

                  var order_item = {
                    product_id          : this.basket[i].product.id,
                    // Allow for custom price modifiers
                    price_modifier_id   : this.basket[i].price_modifier && this.basket[i].price_modifier.id && !this.basket[i].custom_price_modifier_value ? this.basket[i].price_modifier.id : null,
                    custom_price_modifier_value: this.basket[i].custom_price_modifier_value ? this.basket[i].custom_price_modifier_value : null,
                    message             : this.basket[i].message,
                    fulfilment_method_id : this.basket[i].quantity_configs[c].delivery_type || this.basket[i].delivery_type,
                    scheduled_for: this.getScheduledForDateTime(i,c)
                  };
                  
                  const itemRecipient = this.basket[i].quantity_configs[c].recipient_type
                  if(!!itemRecipient) {
                      order_item['recipient'] = itemRecipient
                  }

                  // if the product has an automatic promotion, use it.
                  if(this.basket[i].product.AutomaticPromotions.data.length)
                    payload.discounts.push({'promotion_id':this.basket[i].product.AutomaticPromotions.data[0].id});

                  // non group fulfilment options
                  if(!payload.group_fulfilment){
                    if(order_item.fulfilment_method_id == 2){ // postal fulfilment
                      order_item.fulfilment_address = {
                        name          : this.basket[i].quantity_configs[c].name,
                        address_line_1: this.basket[i].quantity_configs[c].address_line_1,
                        address_line_2: this.basket[i].quantity_configs[c].address_line_2,
                        town_city     : this.basket[i].quantity_configs[c].town_city,
                        postcode      : this.basket[i].quantity_configs[c].postcode,
                        country_code  : this.basket[i].quantity_configs[c].country_code,
                      },
                      order_item.postage_category_id = this.basket[i].quantity_configs[c].post_type.id;

                    } else if(order_item.fulfilment_method_id == 1 || order_item.fulfilment_method_id == 10 && itemRecipient !== 'Myself'){ // email fulfilment
                      order_item.fulfilment_email = this.basket[i].quantity_configs[c].email;
                      order_item.fulfilment_contact = {
                        email       : this.basket[i].quantity_configs[c].email,
                        first_name  : this.basket[i].quantity_configs[c].first_name,
                        last_name   : this.basket[i].quantity_configs[c].last_name,
                        phone_number: this.basket[i].quantity_configs[c].phone_number
                      };
                    }

                  }

                  if(this.basket[i].product.TicketProductConfig) {
                    order_item.BookingInput = {
                      unit_id: this.basket[i].unit_id,
                      event_slot_id: this.basket[i].event_slot_id
                    }
                  }

                  payload.order_items.push(order_item);

              }
          }



          // create basket total
          for(let i = 0; i < this.basket.length; i++){
            if (this.basket[i].custom_price_modifier_value || !this.basket[i].price_modifier) {
              payload.total += this.basket[i].custom_price_modifier_value * this.basket[i].quantity;
            } else {
              payload.total += (this.basket[i].price_modifier.price * this.basket[i].quantity);
            }
          }

          payload.total = payload.total - this.basketDiscountValue;


          if(this.checkoutPromoCode.code){

              payload.discounts.push({'promotion_code':this.checkoutPromoCode.code});

          }

          // add postage costs
          if(payload.group_fulfilment){

            var has_postage_option = false;
            for(let i = 0; i < payload.order_items.length; i++){
                if(payload.order_items[i].fulfilment_method_id == 2) // if postal fulfilment, set has_postage_option to true
                  has_postage_option = true;
            }

            if(this.$store.getters['basket/getGroupedFulfilmentConfig'].post_type.price && has_postage_option){
                payload.total += this.$store.getters['basket/getGroupedFulfilmentConfig'].post_type.price;
            }

          }else{
              for(let i = 0; i < this.basketGroupedByDeliveryType.post.items.length; i++){
                  for(let a = 0; a < this.basketGroupedByDeliveryType.post.items[i].quantity_configs.length; a++){
                    if(this.basketGroupedByDeliveryType.post.items[i].quantity_configs[a].post_type)
                      payload.total += (this.basketGroupedByDeliveryType.post.items[i].quantity_configs[a].post_type.price);
                  }
              }
          }
          
          // lets work out the total for the digital delivery fees
          payload.total += this.getDigitalDeliveryFee(payload);

          if(!payload.discounts.length)
            delete payload.discounts;

          return payload;

        },


        /**
         * Returns all shop products
         * @return array of products
         */

        products(){
            return this.$store.getters.getProducts;
        },


        /**
         * Groups basket by delivery type
         * @return object of arrays
         */

        basketGroupedByDeliveryType(){

            var postItems = this.basket.filter(product => product.delivery_type == 2);
            var emailItems = this.basket.filter(product => (product.delivery_type == 1 || product.delivery_type == 10));

            return {

                'post'  : {
                    items: postItems,
                    quantity : postItems.reduce((quantity, product) => {return quantity += parseInt(product.quantity)}, 0)
                },
                'email'  : {
                    items: emailItems,
                    quantity : emailItems.reduce((quantity, product) => {return quantity += parseInt(product.quantity)}, 0)
                },


            }

        },
        canDeliverGroupedFulfilmentBySMS() {
            // It should be impossible for some digital products to have SMS fulfilment and others not when on grouped fulfilment. However we check
            // here to make sure we can fulfil all items by SMS
            const basketHasEmailItems = this.basketGroupedByDeliveryType.email?.items?.length;
            const allEmailItemsHaveSms = this.basketGroupedByDeliveryType.email?.items?.every((item) => !!item.product?.FulfilmentMethods?.find(fm => fm.id == 10));
            return !!basketHasEmailItems && allEmailItemsHaveSms
        },
        

        /**
         * Returns whether the age has been verified for the order
         * @return bool
         */
        ageVerified(){
          return this.$store.getters.getAgeVerified;
        },

        accountDateFormat() {
            return this.$store.getters.getAccountDateFormat;
        }
    }

}
